import React, { Component } from "react";
import $ from "jquery";

export default class ScreenLoader extends Component {
  componentDidMount() {
    setTimeout(() => {
      $(".loader-section").addClass("hide-loader");
    }, 1200);
  }
  render() {
    return (
      <div className="loader-section">
        <div className="inner">
          <div style={{ display: "flex", flexDirection: "column" }}>
            <img
              src={require("../../assets/img/unnamed.png")}
              className="logo-img"
            />
            <img
              src={require("../../assets/img/loaders/loader-1.gif")}
              className="loader"
            />
          </div>
        </div>
      </div>
    );
  }
}
